import { useState, useMemo, useEffect } from "react";

export function usePagination(data = [], pageSize = 10) {
  const [currentPage, setCurrentPage] = useState(1);

  const safeData = Array.isArray(data) ? data : [];
  const lastPage = Math.max(1, Math.ceil(safeData.length / pageSize));

  useEffect(() => {
    if (currentPage > lastPage) {
      setCurrentPage(1);
    }
  }, [data, pageSize, lastPage]);

  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    const end = start + pageSize;
    return safeData.slice(start, end);
  }, [safeData, currentPage, pageSize]);

  const paginationInfo = {
    current_page: currentPage,
    last_page: lastPage,
    prev_page_url: currentPage > 1 ? true : null,
    next_page_url: currentPage < lastPage ? true : null,
  };

  const onPageChange = (page) => {
    if (page < 1 || page > lastPage) return;
    setCurrentPage(page);
  };

  return { paginatedData, paginationInfo, onPageChange, setCurrentPage };
}
